<div class='fullcontainer'>
<app-skip-vor-and-absence [data]='this.absenceAndVors'></app-skip-vor-and-absence>
  <!-- <div class='titleContainer'>
    <h1 class='header' style='color: white;'>Skip Job Allocation</h1>
  </div> -->
<app-timeline-skip-toolbar></app-timeline-skip-toolbar>

  <!-- <div class='notesContainer'>
    <textarea class='form-control' style='background: white;margin:0;padding:0;width:90%;height:10rem;' placeholder="Enter notes here"></textarea>

  </div> -->

  <br />
  <br />
  <br />
  <div class='colorCodeContainer' style='color:white;font-weight: bold;padding-left: 15rem;'>
    <button class='btn btn-secondary' (click)='this.openModal("vorModal")'><i class="fas fa-wrench"></i> View VORs and Absence</button>&nbsp;

    <span srtyle='color:#2c3e50'>Key:</span>
    <span style='padding: 0.5rem; background: #bdc3c7;width:0.5rem;'></span> Pending
    <span style='padding: 0.5rem; background: rgb(39, 174, 96);width:0.5rem;'></span> Approved
    <span style='padding: 0.5rem; background: rgb(155, 89, 182);width:0.5rem;'></span> Completed
    <span style='padding: 0.5rem; background: #2980b9;width:0.5rem;'></span> Invoiced
    <span style='padding: 0.5rem; background: pink;width:0.5rem;'></span> Previous day's job
  </div>
  <br />
  <br />
  <br />
  <div class='timelineContainer'>
    <app-timeline-skip-accepted-jobs [date]='this.date'></app-timeline-skip-accepted-jobs>
    <app-timeline-skip-main [date]='this.date'></app-timeline-skip-main>
  </div>
</div>
